<template>
<section class="view">
    <Breadcrumb :breadcrumb="breadcrumb"/>
        <div class="row mb-0 align-items-md-center duties">
            <div class="col-md-auto py-0">
                <h1 class="view__title title--1" v-html="`${title_page}`"/>
            </div>
        </div>

        <div class="row">
            <div class="col-md-2" >
                <div class="formdynamic__item__field">
                    <label class="modal-label" v-html="'Select report view'"/>
                    <select class="input-field custom-select" v-model="time_detail" style="max-width: 100%">
                        <option v-html="'Select an option'" :value="''"/>
                        <option v-for="(item, i) in time_detail_options" :key="i" v-html="item.name" :value="item.id"/>
                    </select>
                </div>
            </div>
            <div v-if="time_detail" class="col-md-10 py-0 ml-md-auto">
            <FormDynamic 
                :form_format="form_format"
                :form_data="form_data"
                :array_options="array_options"
                content_align_x="ddd"
            />
            </div>
        </div>
        <AssociateTimeDetail 
            v-if="time_detail === 1"
            :daily_assignment_id="daily_assignment_id"
            :form_data="form_data"
        />
        <SupervisorTimeDetail 
            :time_detail_options="time_detail_options"
            :time_detail="time_detail"
            v-else-if="time_detail === 2"
            :daily_assignment_id="daily_assignment_id"
            :form_data="form_data"
        />
        <AbbreviationTimeDetail 
            v-else-if="time_detail === 3"
            :daily_assignment_id="daily_assignment_id"
            :form_data="form_data"
        />
    <WaitingModal/>
</section>
</template>

<script>
import axios                    from    'axios'
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import AssociateTimeDetail      from    './AssociateTimeDetail/AssociateTimeDetail'
import SupervisorTimeDetail     from    './SupervisorTimeDetail/SupervisorTimeDetail'
import AbbreviationTimeDetail   from    './AbbreviationTimeDetail/AbbreviationTimeDetail'
import FormDynamic              from '@/components/FormDynamic.vue'
import Methods                  from    './Methods'
import Resources                from    './resources'
import FormResources            from    './form_resources'
import moment from 'moment'

/**********styles **********************************************/
import 'vuetify/dist/vuetify.min.css'
import { Notyf }    from    'notyf'
import 'notyf/notyf.min.css' // for React and Vue
const notyf = new Notyf({
    duration: 8000,
})
/***************************************************************/

export default {

    name: 'TimeDetails',

    components: {
        Breadcrumb,
        WaitingModal,
        AssociateTimeDetail,
        SupervisorTimeDetail,
        AbbreviationTimeDetail,
        FormDynamic
    },

    mixins:[
        Methods,
    ],

    data() {
        return {
            notyf,
            axios,
            user:                   this.get_user(),
            daily_assignment_id:    this.$route.params.id,
            parent:                 {},
            parent_id:              '',
            title_page:             'Quick Reports',
            rest_api:               `/daily_assignments/${JSON.stringify({ single_view: true, id: this.$route.params.id })}`,
            lite_rest_api:          ``,
            time_detail:            '',
            breadcrumb:             Resources.breadcrumb,
            time_detail_options:    Resources.time_detail_options,
            array_options: {},
            form_format:    FormResources.form_format,
            form_data:      FormResources.form_data
        }
    },

    methods:{

        fill_data(data)
        {
            this.parent = data.daily_assignment

            let array_options = data

            this.array_options =
            {
                shift_id: array_options.shifts,
                day_id:   array_options.days,
                daily_assignment_id: array_options.daily_assignments,
                supervisor_id: array_options.supervisors,
                shift_class_id: Resources.class_shift_options

            }

            this.form_data.day_id = moment().day()
            this.form_data.daily_assignment_id.push(this.$route.params.id)
            this.breadcrumb.push( 
                {
                    name:   `${this.parent.description}`,
                    href:   `/assignment-daily-assignments/${this.parent.id}`,
                    arrow:  "<span class='slash'>/</span>",
                },
                {
                    name:   'Quick Reports',
                    href:   `/assignment-daily-assignments-time-details/${this.daily_assignment_id}`,
                    arrow:  "",
                },
            )
        },

    },

    watch: {

        async 'form_data.all_assignments' (val)
        {
            this.form_format[2].disabled = val
        },

        time_detail(val)
        {
            if(val == 1)
            {
                this.title_page = 'Associate - Quick Report'
            }
            else if(val == 2)
            {
                this.title_page = 'Supervisor - Quick Report'
            }
            else if(val == 3)
            {
                this.title_page = 'Abbreviated Quick Report'
            }
            else 
            {
                this.title_page = 'Quick Report'
            }
        }
    },

    async mounted()
    {
        await this.api_request()
    },
}
</script>